import _classCallCheck from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import Voice from "./Voice";

var ComplexVoice =
/*#__PURE__*/
function (_Voice) {
  _inherits(ComplexVoice, _Voice);

  function ComplexVoice(context, type) {
    var _this;

    var amount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;
    var wideness = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 50;
    var analog = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 5;

    _classCallCheck(this, ComplexVoice);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ComplexVoice).call(this, context, "none"));
    _this.type = type;
    _this.widen = wideness;
    _this.analog = analog;
    _this.amount = amount;
    _this.output.gain.value = 1 / amount;
    return _this;
  }

  _createClass(ComplexVoice, [{
    key: "init",
    value: function init() {
      var amount = this.amount;

      for (var i = 0; i < amount; i++) {
        var osc = this.context.createOscillator();
        osc.type = this.type;

        if (i > 0) {
          var detune = i / amount * this.widen;

          if (i % 1 == 0) {
            detune = -detune;
          }

          osc.detune.value = detune + this.analog * Math.random();
        }

        osc.connect(this.ampEnvelope.output);
        osc.start(this.context.currentTime);
        this.partials.push(osc);
      }
    }
  }, {
    key: "wideness",
    set: function set(value) {
      var _this2 = this;

      this.widen = value;
      var amount = this.amount;
      this.partials.forEach(function (osc, i) {
        if (i > 0) {
          var detune = i / amount * _this2.widen;

          if (i % 1 == 0) {
            detune = -detune;
          }

          osc.detune.value = detune + _this2.analog * Math.random();
        }
      });
    },
    get: function get() {
      return this.widen;
    }
  }]);

  return ComplexVoice;
}(Voice);

export { ComplexVoice as default };